import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as Color from 'color';
import { Storage } from '@ionic/storage';
import { retry } from 'rxjs/operators';

@Injectable()
export class ThemeService
{

}
